import BaseAPI from '../base'

function getAll(start, end) {
    return BaseAPI.get(`stats/all`, {
        start,
        end
    });
}

function getMonthly(cafe_id, previous) {
    return BaseAPI.get(`stats/monthly/${cafe_id}`, {
        prev: previous ? true : undefined
    });
}

function getTopDishes() {
    return BaseAPI.get(`stats/top_dishes`);
}

function getForMode(cafe_id, mode, start, end) {
    return BaseAPI.get(`stats/mode/${cafe_id}/${mode}`, {
        start, end
    });
}

function getVisits(cafe_id, mode, start, end) {
    return BaseAPI.get(`stats/visits/${cafe_id}/${mode}`, {
        start,
        end
    });
}

function getClients(cafe_id) {
    return BaseAPI.get(`stats/clients/${cafe_id}`);
}

function getTopClients(cafe_id) {
    return BaseAPI.get(`stats/top_clients/${cafe_id}`);
}

function getTopWaiters(cafe_id) {
    return BaseAPI.get(`stats/top_waiters/${cafe_id}`);
}

function importClients(file) {
    let fd = new FormData();
    fd.append('file', file);

    return BaseAPI.root.post(`stats/import_clients`, fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

function getClientOrdersHistory(cafe_id, client_id) {
    return BaseAPI.get(`stats/client_orders/${cafe_id}/${client_id}`);
}

function getDailySummary(cafe_id) {
    return BaseAPI.get(`stats/daily_summary/${cafe_id}`);
}

function getProfileFilling(cafe_id) {
    return BaseAPI.get(`stats/profile_filling/${cafe_id}`);
}

function computeOrdersStats(cafe_id, start, end) {
    return BaseAPI.get(`stats/compute/orders/${cafe_id}`, {
        start,
        end
    })
}

function computeGuestsStats(cafe_id, start, end) {
    return BaseAPI.get(`stats/compute/guests/${cafe_id}`, {
        start,
        end
    })
}

function computeFinancesStats(cafe_id, start, end) {
    return BaseAPI.get(`stats/compute/finances/${cafe_id}`, {
        start,
        end
    })
}

function computeAverageCheckStats(cafe_id, start, end) {
    return BaseAPI.get(`stats/compute/average/${cafe_id}`, {
        start,
        end
    })
}

function computeTablesStats(cafe_id, start, end) {
    return BaseAPI.get(`stats/compute/tables/${cafe_id}`, {
        start,
        end
    })
}

function computeSummary(cafe_id, start, end) {
    return BaseAPI.get(`stats/compute/summary/${cafe_id}`, {
        start,
        end
    });
}

function getClientProfile(cafe_id, client_id) {
    return BaseAPI.get(`stats/client_profile/${cafe_id}/${client_id}`);
}

function computeLoyaltySummary(cafe_id) {
    return BaseAPI.get(`stats/loyalty_summary/${cafe_id}`);
}

export default {
    getAll,
    getMonthly,
    getTopDishes,
    getForMode,
    getVisits,
    getClients,
    importClients,
    getTopClients,
    getTopWaiters,
    getClientOrdersHistory,
    getDailySummary,
    getProfileFilling,
    computeOrdersStats,
    computeSummary,
    computeGuestsStats,
    computeFinancesStats,
    computeAverageCheckStats,
    computeTablesStats,
    getClientProfile,
    computeLoyaltySummary
}
